export enum LvfTicketArticleNature {
  PERISHABLE_PRODUCT = 1,
  SERVICE = 2,
  VEHICLE = 3,
  VEHICLE_TYPE = 4
}

